module.exports = __webpack_public_path__ + "img/skie-angel.8cdcb33a.png";